import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { cloneDeep } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { baseErpUrl, baseUrl } from '../../constants/environment';
import styled from 'styled-components';
import { RenderActionModal } from './ProductList';
import ProductContentPageAdd from './components/ProductContentPageAdd';
import ProductContentPageDetail from './components/ProductContentPageDetail';
import ProductContentPageEdit from './components/ProductContentPageEdit';
import { usageList } from "./components/ProductInfo"

interface Props {
    history: any,
    location: any,
    match: any,
    user: any,
}

export const Type = [
    {
        label: "Thường",
        value: "normal"
    },
    {
        label: "Lô",
        value: "batch"
    }
]

const Detail: React.FC<Props> = (props: Props) => {
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(props.match.params.id);
    const [onlyView, setOnlyView] = useState(false);
    const [data, setData] = useState<any>({
        status: 1,
        type: 'normal',
        ingredient:[]
    });
    const [dataActive, setDataActive] = useState<any>({});
    const [imgs, setImgs] = useState<any>([]);
    const [stock, setStock] = useState<any>([
        {
            branch_id: "",
            quantity: "",
            price_cost: "",
        }
    ]);
    const [unit, setUnit] = useState<any>([
        {
            name: '',
            quantity_conversion: ''
        }
    ]);
    const [attributes, setAttributes] = useState<any>([
        {
            name: "",
            properties: [],
        }
    ]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [type, setType] = useState(props.match.params.action);
    const [action, setAction] = useState();
    const [category, setCategory] = useState<any>([]);
    const [brand, setBrand] = useState<any>([]);
    const [origin, setOrigin] = useState<any>([]);
    const [branch, setBranch] = useState<any>([]);
    const [varriant, setVarriant] = useState<any>([]);
    const [stockConfig, setStockConfig] = useState<any>([]);
    const [isEmptyVarriant, setIsEmptyVarriant] = useState<any>(true);
    const [age, setAge] = useState<any>();
    const [pathologicals, setPathologicals] = useState<any>();
    const ready = useRef<any>(null)
    const contentPage = useRef<any>(null)

    useEffect(() => {
        if( id !== 'add' && id !== undefined && ready.current !== true){

        }else{
            genVariant()
        }
    }, [unit, attributes, data?.name, data?.sku, stock]);

    useEffect(() => {
        if (id && id !== 'add') {
            loadData(id)
            document.title = 'Chỉnh sửa sản phẩm'
            
        }else{
            document.title = 'Thêm mới sản phẩm'
        }
        if (type === 'view') {
            setOnlyView(true)
            document.title = 'Chi tiết sản phẩm'
        }
    }, [id]);


    useEffect(() => {
        loadInit();
        fetchAge();
        fetPathologicals();
    }, []);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const loadInit = async () => {
        const params:any = {
            page: 1,
            limit: 200,
        }
        if( id == 'add'){
            params.status = 1
        }
        const [
            responseCategory,
            responseBrand,
            responseOrigin,
            responseBranch,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/category`, params),
            APIClient.GET(`${baseUrl}/product-brand`, params),
            APIClient.GET(`${baseUrl}/product-origin`, params),
            APIClient.GET(`${baseUrl}/branch`, params),
        ]);
        if (responseCategory.response?.data !== undefined) {
            let ListArr: any = [];
            responseCategory.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setCategory(ListArr)
        }
        if (responseBrand.response?.data !== undefined) {
            let ListArr: any = [];
            responseBrand.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBrand(ListArr)
        }
        if (responseOrigin.response?.data !== undefined) {
            let ListArr: any = [];
            responseOrigin.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setOrigin(ListArr)
        }
        if (responseBranch.response?.data !== undefined) {
            let ListArr: any = [];
            responseBranch.response?.data?.map((e: any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setBranch(ListArr)
        }
    }

    const loadData = async (id: number) => {
        const url = `${baseUrl}/product/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const product_attributes = response.response?.product_attributes?.reduce((prev:any, item:any)=>{
                const newProperties = item?.properties?.reduce((prevValue:any, itemValue:any)=>{
                    prevValue = [...prevValue, {
                        ...itemValue,
                        id_curent: itemValue?.id,
                        id: itemValue?.name?.toLowerCase(),
                        text: itemValue?.name
                    }]
                    return prevValue
                },[])
                prev = [...prev, {
                    ...item,
                    properties: newProperties
                }]
                return prev
            },[]);
            const product_images = response.response?.product_images;
            const product_units = response.response?.product_units;
            const product_variants = response.response?.product_variants;
            const product_stock_firsts = response.response?.product_stock_firsts?.reduce((prev:any, item:any)=>{
                prev = [...prev, {
                    ...item,
                    branch_id: item?.branch_id?.id
                }]
                return prev
            },[]);
            const product_stock_config = resData?.product_stock_config?.reduce((prev:any, item:any)=>{
                if(item?.variant_id){
                    prev = [...prev, {
                        id: item?.id,
                        branch_id: item?.branch_id?.id,
                        product_id: item?.product_id?.id,
                        variant_id: item?.product_id?.id,
                        sku: item?.variant_id?.sku,
                        stock_max: item?.stock_max,
                        stock_min: item?.stock_min
                    }]
                }else{
                    prev = [...prev, {
                        id: item?.id,
                        sku: item?.product_id?.sku,
                        branch_id: item?.branch_id?.id,
                        product_id: item?.product_id?.id,
                        variant_id: null,
                        stock_max: item?.stock_max,
                        stock_min: item?.stock_min
                    }]
                }
                return prev
            },[]);
            // let usage = resData?.usage?.split(",")
            // usage = usage?.reduce((prevUsage:any, itemUsage:any)=>{
            //     if(itemUsage){
            //         prevUsage = [...itemUsage,itemUsage]   
            //     }
            //     return prevUsage
            // },[])

            let usage_data: any[] = []
            let resData_usage = resData?.usage?.split(",");
            let usage = usageList?.map((item: any) => {
                resData_usage?.filter((option: any) => {
                    if(item?.value == option) {
                        usage_data.push(item)
                    }
                })
            })
            let ingredient = resData?.ingredient?.split(",")
            ingredient = ingredient?.reduce((prevIngredient:any, itemIngredient:any)=>{
                if(itemIngredient){
                    prevIngredient = [...prevIngredient,{
                        id:itemIngredient,
                        name:itemIngredient,
                        text:itemIngredient,
                    }]   
                }
                return prevIngredient
            },[])

            const Arr_product_pathological_ids: any = [];
            resData?.product_pathological_ids?.map((item: any) => {
                Arr_product_pathological_ids?.push({
                    ...item,
                    value: item?.id,
                    label: item?.name
                })
            })

            const NewData = {
                ...resData,
                attributes_status: product_attributes?.length > 0 ? 1: 0,
                expiration_status: resData?.expiration_day_number ? 1 : 0,
                stock_status: resData?.stock_min ? 1 : 0,
                stock_first_status: product_stock_firsts?.length > 0 ? 1: 0,
                unit_status: product_units?.length > 0 ? 1: 0,
                category_id: resData?.category_id?.id,
                brand_id: resData?.brand_id?.id,
                brand: resData?.brand_id,
                origin: resData?.origin_id,
                origin_id: resData?.origin_id?.id,
                ingredient: ingredient,
                usage: usage_data,
                product_pathological_ids: Arr_product_pathological_ids,
                product_age_id: resData?.product_age_id?.id
            }
            setData(NewData)
            setIsEmptyVarriant((product_attributes?.length > 0 || product_units?.length > 0) ? false : true)
            setAttributes(product_attributes)
            setStock(product_stock_firsts)
            setImgs(product_images)
            setUnit(product_units)
            setStockConfig(product_stock_config)
            const variants = await parseVariant(product_variants);
            setVarriant(variants)
            ready.current = true
            if(variants && variants[0]){
                setDataActive(variants[0])
            }else{
                setDataActive(NewData)
            }
        }
    }

    const loadInfoProductErp = async (erp_code: string) => {
        if(!erp_code){
            return toast.warning("Vui lòng nhập mã SKU ERP")
        }
        const url = `${baseErpUrl}/api/drnutri/product_product/list`;
        setLoading(true)
        let response: any = await APIClient.POST(url,{
            "params": {
                "domain": [

                    // ["service_name", "in", ["vnpost", "ems", "viettelpost"]],
                    [
                        "default_code",
                        "=",
                        erp_code
                    ]
                ],
                "context2": {
                "lang": "vi_VN"
                },
                "offset": 0,
                "limit": 1,
                "order": "id desc"
            }
        });
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response?.response?.result?.items;
            if(resData?.length === 0){
                return toast.warning("Không tồn tại mã SKU ERP này")
            }
            const product = {
                ...data,
                name:resData[0]?.name,
                barcode:resData[0]?.barcode,
                price:resData[0]?.lst_price,
                minimum_unit:resData[0]?.uom_id?.name,
                type: resData[0]?.tracking === 'batch' ? 'batch':'normal',
                weight: resData[0]?.weight,
                
            }
            setData(product)
            setDataActive(product)
            contentPage.current && contentPage.current.validationFrom && contentPage.current.validationFrom()
            toast.info("Đã lấy thông tin từ ERP về thành công")
        }
    }

    const parseVariant = async (variantTmp:any)=>{
        const variant = variantTmp?.reduce((prev:any, item:any)=>{
            if(!item?.parent_id){
                const units = variantTmp?.filter((itemUnit:any)=>{
                    return itemUnit?.parent_id?.id == item?.id
                })
                const warehouse = item?.product_stock_firsts?.reduce((prevStock:any, itemStock:any)=>{
                    prevStock = [...prevStock,{
                        ...itemStock,
                        branch_id: itemStock?.branch_id?.id,
                        quantity: itemStock?.quantity || '',
                        price_cost: itemStock?.price_cost || '',
                    }]
                    return prevStock
                },[])
                prev = [...prev,{
                    ...item,
                    units: units,
                    warehouse: warehouse,
                }]
            }
            return prev
        },[])
        return variant
    }

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        setData({
            ...data,
            [name]: value
        })
    }

    const handleChangeStockConfig = (sku:string, branch_id:number, name: string, value: any) => {
        if(!sku) sku = data.sku
        let index = stockConfig.findIndex((config:any) => config.sku == sku && config.branch_id == branch_id)
        if(index !== -1){
            stockConfig[index] = {
                ...stockConfig[index],
                [name]: value
            }
            setStockConfig(stockConfig)
        }else{
            stockConfig.push({
                sku: sku,
                branch_id: branch_id,
                [name]: value
            })
            setStockConfig(stockConfig)
        }
        
    }

    useEffect(()=>{
        //
        if(varriant?.length === 0) return
        const productStockConfigLockup:any = {}
        stockConfig?.map((item:any)=>{
            if(!productStockConfigLockup[item?.sku]) productStockConfigLockup[item?.sku] = {}
            if(!productStockConfigLockup[item?.sku][item?.branch_id]) productStockConfigLockup[item?.sku][item?.branch_id] = {}
            productStockConfigLockup[item?.sku][item?.branch_id] = item
        })
        const defaultStockConfig = {
            stock_max: data?.stock_max,
            stock_min: data?.stock_min,
        }
        //tạo caadu hình định mức cho các biến theerr mới
        const productStockConfigNew = varriant?.reduce((prev:any, item:any)=>{
            const productStockConfigBranch = branch?.reduce((prevBranch:any, itemBranch:any)=>{
                const dataCurrent = productStockConfigLockup[item?.sku] && productStockConfigLockup[item?.sku][itemBranch?.id] ? productStockConfigLockup[item?.sku][itemBranch?.id] : {...defaultStockConfig, sku:item?.sku, branch_id: itemBranch}
                prevBranch = [...prevBranch,{
                    ...dataCurrent
                }]
                return prevBranch
            },[])
            //
            const productStockConfigUnit = item?.units?.reduce((prevUnit:any, itemUnit:any)=>{
                const productStockConfigUnitBranch = branch?.reduce((prevUnitBranch:any, itemUnitBranch:any)=>{
                    const dataCurrent = productStockConfigLockup[itemUnit?.sku] && productStockConfigLockup[itemUnit?.sku][itemUnitBranch?.id] ? productStockConfigLockup[itemUnit?.sku][itemUnitBranch?.id] : {...defaultStockConfig, sku:itemUnit?.sku, branch_id: itemUnitBranch}
                    prevUnitBranch = [...prevUnitBranch,{
                        ...dataCurrent
                    }]
                    return prevUnitBranch
                },[]) || []
                prevUnit = [...prevUnit,...productStockConfigUnitBranch]
                return prevUnit
            },[]) || []
            prev = [...prev, ...productStockConfigBranch, ...productStockConfigUnit]
            return prev
        },[])
        setStockConfig([...productStockConfigNew])
    },[varriant])

    useEffect(()=>{
        if(!data?.stock_status){
            setData({
                ...data,
                stock_min: null,
                stock_max: null,
            })
        }
    },[data?.stock_status])

    useEffect(()=>{
        if(!data?.stock_first_status){
            setStock([
                {
                    branch_id: "",
                    quantity: "",
                    price_cost: "",
                }
            ])
        }
    },[data?.stock_first_status])

    useEffect(()=>{
        if(!data?.unit_status || (data?.unit_status && unit?.length === 0)){
            setUnit([
                {
                    name: '',
                    quantity_conversion: ''
                }
            ])
        }
    },[data?.unit_status])

    useEffect(()=>{
        if(!data?.attributes_status|| (data?.attributes_status && attributes?.length === 0)){
            setAttributes([
                {
                    name: "",
                    properties: [],
                }
            ])
        }
    },[data?.attributes_status])

    const toLowerCaseNonAccentVietnamese = (str: string) => {
        str = str.toLowerCase();
        str = str.replace(/A|Á|À|Ã|Ạ|Â|Ấ|Ầ|Ẫ|Ậ|Ă|Ắ|Ằ|Ẵ|Ặ/g, "A");
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/E|É|È|Ẽ|Ẹ|Ê|Ế|Ề|Ễ|Ệ/, "E");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/I|Í|Ì|Ĩ|Ị/g, "I");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/O|Ó|Ò|Ỏ|Õ|Ọ|Ô|Ố|Ồ|Ỗ|Ộ|Ơ|Ớ|Ờ|Ỡ|Ợ/g, "O");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/U|Ú|Ù|Ũ|Ụ|Ư|Ứ|Ừ|Ữ|Ự/g, "U");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/Y|Ý|Ỳ|Ỹ|Ỵ/g, "Y");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/Đ/g, "D");
        str = str.replace(/đ/g, "d");
        str = str.replace(/ /g, "");
        // Some system encode vietnamese combining accent as individual utf-8 characters
        str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng 
        str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
        return str;
    }

    const updateSkuVariantBySkuProduct = (sku:any)=>{
        if(!data?.sku) return sku
        const skuArray = sku?.split("-") || [];
        skuArray[0] = data?.sku
        return skuArray.join('-')
    }

    const getVariantItem = (sku:string, isUnit?: boolean)=>{
        const data = cloneDeep(varriant)
        const SKU = updateSkuVariantBySkuProduct(sku)
        let varriantItem:any = []
        if(isUnit){
            varriantItem = data.map((k:any) => k?.units?.filter((e:any) => {
                const ItemSKU = updateSkuVariantBySkuProduct(e?.sku)
                return ItemSKU == SKU 
            }));
            varriantItem = varriantItem?.filter((e:any)=>{
                return e?.length > 0
            })
            return varriantItem && varriantItem[0] && varriantItem[0][0]
        }
        varriantItem =  data?.filter((item:any)=>{
            const ItemSKU = updateSkuVariantBySkuProduct(item?.sku)
            return ItemSKU == SKU
        })
        return varriantItem && varriantItem[0]
    }

    const getBranchItem = (branch_id:number, dataVariant: any)=>{
        const branchItem:any =  dataVariant?.filter((item:any)=>{
            return item?.branch_id == branch_id
        })
        return branchItem && branchItem[0]
    }

    const genVariant = () => {
        let sets = [[]];
        const id_obj: any = {};
        attributes.forEach((attribute: any) => {
            const new_sets: any = [];
            if(attribute?.properties?.length > 0){
                attribute?.properties.forEach(({ name }: any) => {
                    new_sets.push(Array.from(sets, set => [...set, name]));
                    id_obj[name] = { name: attribute.name, attribute_value: name };
                });
                sets = new_sets.flatMap((set: any) => set);
            }
        });
        if(sets?.length === 1 && sets[0]?.length === 0){
            const newVariantsUnits = unit?.reduce((prevCon:any, itemCon:any)=>{
                if(itemCon?.name && itemCon?.quantity_conversion){
                    const skus = data?.sku ? [data?.sku] : [];
                    const nameUnit = itemCon?.name
                    const valueUnit = PriceUtils.removeDot(itemCon?.quantity_conversion || 0)
                    const skusUnit = [...skus, toLowerCaseNonAccentVietnamese(nameUnit)];
                    const skuUnitItem = skusUnit.join("-").toUpperCase();
                    const setUnitItem = getVariantItem(skuUnitItem)
                    const newItemCon = {
                        ...setUnitItem,
                        unit_value: valueUnit,
                        unit_name: nameUnit,
                        parent: data?.sku,
                        isRoot: true,
                        name: [data?.name, nameUnit].join(" - "),
                        sku: skuUnitItem,
                        barcode: setUnitItem?.barcode || '',
                        price: setUnitItem?.price?.length > 0 ? setUnitItem?.price : (PriceUtils.removeDot(data?.price || 0) * valueUnit) || '',
                        price_import: setUnitItem?.price_import?.length  > 0 ? setUnitItem?.price_import : (PriceUtils.removeDot(data?.price_import || 0) * valueUnit) || '',
                        price_wholesale: setUnitItem?.price_wholesale?.length  > 0 ? setUnitItem?.price_wholesale : (PriceUtils.removeDot(data?.price_wholesale || 0) * valueUnit) || '',
                        weight: setUnitItem?.weight?.length  > 0 ? setUnitItem?.weight : (PriceUtils.removeDot(data?.weight || 0) * valueUnit) || '',
                        longs: setUnitItem?.longs?.length  > 0 ? setUnitItem?.longs : (PriceUtils.removeDot(data?.longs || 0)) || '',
                        width: setUnitItem?.width?.length  > 0 ? setUnitItem?.width : (PriceUtils.removeDot(data?.width || 0)) || '',
                        height: setUnitItem?.height?.length  > 0 ? setUnitItem?.height : (PriceUtils.removeDot(data?.height || 0)) || '',
                        vat: setUnitItem?.vat?.length > 0 ? setUnitItem?.vat : data?.vat || '',
                    }
                    prevCon = [...prevCon, newItemCon]
                }
                return prevCon
            },[])
            setVarriant([...newVariantsUnits])
            return;
        }
        //lấy kho cho nhập tồn đầu
        const warehouse_stock = stock?.reduce((prev: any, item: any) => {
            prev.warehouse_selected = [...prev.warehouse_selected, item?.branch_id]
            if (item?.id) {
                prev.warehouse_disable = [...prev.warehouse_disable, item?.branch_id]
            }
            return prev
        }, {
            warehouse_selected: [],
            warehouse_disable: [],
        })

        const warehouse = branch?.reduce((prev: any, item: any) => {
            if (warehouse_stock?.warehouse_selected.indexOf(Number(item?.id)) !== -1) {
                if (warehouse_stock?.warehouse_disable.indexOf(Number(item?.id)) !== -1) {
                    item.disabled = true
                }
                prev = [...prev, item]
            }
            return prev
        }, []);
        //
        const newVariants = sets?.reduce((prev: any, set: any) => {
            const nameBySet = set.join(" - ")
            const skuBySet = toLowerCaseNonAccentVietnamese(nameBySet)
            const setLowerCaseNonAccentVietnamese = set?.reduce((prevSet: any, itemSet: any) => {
                prevSet = [...prevSet, toLowerCaseNonAccentVietnamese(itemSet)]
                return prevSet
            }, [])
            const skus = data?.sku ? [data?.sku, skuBySet] : setLowerCaseNonAccentVietnamese;
            const skuItem = skus.join("-").toUpperCase();
            const setItem = getVariantItem(skuItem)
            const attribute_values = set.map((name: any) => ({
                name: id_obj[name].name,
                attribute_value: id_obj[name].attribute_value
            }))
            if (attribute_values?.length === 0) {
                return prev
            }

            const units = unit?.reduce((prevCon: any, itemCon: any) => {
                if(itemCon?.name && itemCon?.quantity_conversion){
                    const nameUnit = itemCon?.name
                    const valueUnit = PriceUtils.removeDot(itemCon?.quantity_conversion || 1)
                    const skusUnit = [...skus, toLowerCaseNonAccentVietnamese(nameUnit)];
                    const skuUnitItem = skusUnit.join("-").toUpperCase();
                    const setUnitItem = getVariantItem(skuUnitItem, true)
                    const newItemCon = {
                        ...setUnitItem,
                        unit_value: valueUnit,
                        unit_name: nameUnit,
                        parent: skuItem,
                        name: [data?.name, nameBySet, nameUnit].join(" - "),
                        variant_name: nameBySet,
                        sku: skuUnitItem,
                        barcode: setUnitItem?.barcode || '',
                        price: setUnitItem?.price || (PriceUtils.removeDot(data?.price || 0) * valueUnit) || '',
                        price_import: setUnitItem?.price_import || (PriceUtils.removeDot(data?.price_import || 0) * valueUnit) || '',
                        price_wholesale: setUnitItem?.price_wholesale || (PriceUtils.removeDot(data?.price_wholesale || 0) * valueUnit) || '',
                        weight: setUnitItem?.weight || (PriceUtils?.removeDot(data?.weight || 0) * valueUnit) || '',
                        longs: setUnitItem?.longs || (PriceUtils?.removeDot(data?.longs || 0) ) || '',
                        width: setUnitItem?.width || (PriceUtils?.removeDot(data?.width || 0)) || '',
                        height: setUnitItem?.height || (PriceUtils?.removeDot(data?.height || 0)) || '',
                        vat: setUnitItem?.vat || data?.vat || '',
                    }
                    // console.log('newVariants', setUnitItem, newItemCon)
                    prevCon = [...prevCon, newItemCon]
                }
                return prevCon
            }, [])
            const warehouse_inventory: any = []
            warehouse?.map((itemInWarehouse: any) => {
                const valueCur = getBranchItem(itemInWarehouse?.id, setItem?.warehouse)
                warehouse_inventory.push({
                    branch_id: itemInWarehouse?.id,
                    quantity: valueCur?.quantity || '',
                    price_cost: valueCur?.price_cost || '',
                })
            })

            const newItem = {
                ...setItem,
                name: [data?.name, nameBySet].join(" - "),
                variant_name: nameBySet,
                sku: skuItem,
                barcode: setItem?.barcode || '',
                warehouse: warehouse_inventory || {},
                attribute_values: attribute_values,
                units: units,
                price: setItem?.price || data?.price || '',
                price_import: setItem?.price_import || data?.price_import || '',
                price_wholesale: setItem?.price_wholesale || data?.price_wholesale || '',
                weight: setItem?.weight || PriceUtils?.removeDot(data?.weight || 0) || '',
                longs: setItem?.longs || PriceUtils?.removeDot(data?.longs  ||0 ) || '',
                width: setItem?.width || PriceUtils?.removeDot(data?.width  ||0 ) || '',
                height: setItem?.height || PriceUtils?.removeDot(data?.height  ||0 ) || '',
                vat: setItem?.vat || data?.vat || '',
            }
            prev = [...prev, newItem];
            return prev
        }, [])
        setVarriant([...newVariants])
    }

    const handleChangeVariant = (index:number, name: string, value: any, indexParent:number,) => {
        
        if(indexParent !== null){
            const itemCur = varriant && varriant[indexParent] && varriant[indexParent].units && varriant[indexParent].units[index]
            const newItem = {
                ...itemCur,
                [name] : value
            }
            if(varriant[indexParent]?.units){
                varriant[indexParent].units[index] = newItem
            }
            setVarriant(varriant)
            
        }else{
            
            const newItem = {
                ...varriant[index],
                [name] : value
            }
            varriant[index] = newItem
            setVarriant(varriant)
        }
    }

    // api độ tuổi , bệnh lý
    const fetchAge = async () => {
        const url = `${baseUrl}/product/ages`;
        setLoading(true);
        let response: any = await APIClient.GET(url);
        setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error);
        } else if (response.response?.data !== undefined) {
            let Arr: any = [];
            response.response?.data?.map((item: any) => {
                Arr.push({
                    value: item?.id,
                    label: item?.name,
                    ...item
                })
            })
            setAge(Arr);
        }
    }

    const fetPathologicals = async () => {
        const url = `${baseUrl}/product/pathologicals`;
        setLoading(true);
        let response: any = await APIClient.GET(url);
        setLoading(false);
        if (response.error !== undefined) {
            toast.error(response.error);
        } else if (response.response?.data !== undefined) {
            let Arr: any = [];
            response.response?.data?.map((item: any) => {
                Arr.push({
                    value: item?.id,
                    label: item?.name,
                    ...item
                })
            })
            setPathologicals(Arr);
        }
    }

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: `${type == 'view' ? 'Xem chi tiết' : id !== 'add' ? 'Chỉnh sửa' : 'Tạo'} sản phẩm`, active: true },
                ]}
                title={`${type == 'view' ? data?.name : id !== 'add' ? 'Chỉnh sửa sản phẩm' : 'Tạo sản phẩm'}`}
            />
            <ContentPage
                {...props}
                contentPage={contentPage}
                data={data}
                dataActive={dataActive}
                imgs={imgs}
                stock={stock}
                attributes={attributes}
                unit={unit}
                branch={branch}
                varriant={varriant}
                setData={(val: any) => setData(val)}
                setDataActive={(val: any) => setDataActive(val)}
                setImgs={(val: any) => setImgs(val)}
                setStock={(val: any) => setStock(val)}
                setUnit={(val: any) => setUnit(val)}
                setAttributes={(val: any) => setAttributes(val)}
                handleChangeInput={(val: any) => handleChangeInput(val)}
                category={category}
                brand={brand}
                origin={origin}
                onlyView={onlyView}
                id={id}
                type={type}
                action={action}
                handleActionModal={(data: any) => handleActionModal(data)}
                handleChangeVariant={handleChangeVariant}
                getBranchItem={getBranchItem}
                stockConfig={stockConfig}
                setStockConfig={(val: any) => setStockConfig(val)}
                handleChangeStockConfig={handleChangeStockConfig}
                isEmptyVarriant={isEmptyVarriant}
                loadInfoProductErp={loadInfoProductErp}
                age = {age}
                pathologicals = {pathologicals}
            />
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                <RenderActionModal {...props} closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData(id)} />
            </ModalPopup>
            {loading && <Loader />}
        </React.Fragment>
    );
};

const ContentPage = (props: any) => {
    const {
        data, type, setData, category, brand, origin, onlyView, id, imgs, setImgs, action, handleActionModal,
        branch, stock, setStock, unit, attributes, setAttributes, setUnit, handleChangeInput, varriant, contentPage, age
    } = props
    return(
        <>
            {
            type === 'view' ? <ProductContentPageDetail ref={contentPage} {...props} />
            :id === 'add' ? <ProductContentPageAdd ref={contentPage} {...props} />
            :<ProductContentPageEdit ref={contentPage} {...props} />
            }
        </>
    )
}

export const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export const PageContent = styled.div`
    padding-bottom: 60px;
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`

export default connect(mapState)(Detail)